import React, { useState } from "react";
import styled, { css } from "styled-components";

import PartnerSearchModal from "./PartnerSearchBottomSheet";
import InputCloseImg from "../../assets/input_close_icon.svg";
import MgInput from "../input/MgInput";
import MgDialog from "../Dialog";
import { Common } from "../../styles/Common";

interface Props {
    partnerCode?: string;
    setPartnerCode: (code: string) => void;
}

const PartnerCodeBox: React.FC<Props> = ({ partnerCode, setPartnerCode }) => {
    const [isOpenAgreeModal, setIsOpenAgreeModal] = useState<boolean>(false);
    const [isOpenSearchModal, setIsOpenSearchModal] = useState<boolean>(false);

    return (
        <>
            <BoxEmailStyle>
                <p className="partnerCodeTitle">추천인 코드 (선택)</p>
                <InputBoxStyle>
                    <MgInput value={partnerCode} onChange={() => {}} placeholder="조회하여 입력 가능합니다" isDisabled={true} />
                    <SearchBtnStyle
                        onClick={() => {
                            setIsOpenAgreeModal(true);
                        }}
                    >
                        조회
                    </SearchBtnStyle>
                    {!!partnerCode && (
                        <InputPartnerCloseBtnStyle
                            src={InputCloseImg}
                            alt=""
                            onClick={() => {
                                setPartnerCode("");
                            }}
                        />
                    )}
                </InputBoxStyle>
            </BoxEmailStyle>
            <MgDialog
                addDialogStyle={{
                    zIndex: 3000,
                }}
                open={isOpenAgreeModal}
                onCloseView={() => {
                    setIsOpenAgreeModal(false);
                }}
                contents={
                    <PartnerAgreeContents>
                        <p className="title">추천인 코드 입력 안내</p>
                        <li className="contents">코드 입력 혜택은 따로 명시된 내용이 없는 경우 코드 입력 즉시 지급됩니다</li>
                        <li className="contents">
                            추천인 코드 입력 시 회원님의 구독 결제 정보가 추천인 회원에게 제공될 수 있습니다
                        </li>
                    </PartnerAgreeContents>
                }
                confirmText="동의"
                cancelText="취소"
                confirmStyle={ConfirmStyle}
                cancelStyle={ConfirmStyle}
                onClickSubmit={() => {
                    setIsOpenAgreeModal(false);
                    setIsOpenSearchModal(true);
                }}
            />
            <PartnerSearchModal
                setPartnerCode={setPartnerCode}
                partnerSearchOpen={isOpenSearchModal}
                setPartnerSearchOpen={setIsOpenSearchModal}
                onSubmitConfirmCode={() => {}}
            />
        </>
    );
};

export default PartnerCodeBox;

const BoxEmailStyle = styled.div`
    position: relative;
    .partnerCodeTitle {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: ${Common.colors.normalTextColor};
    }
`;

const InputBoxStyle = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    gap: 8px;
`;

const SearchBtnStyle = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 54px;
    min-width: 60px;
    padding: 10px 12px;
    border-radius: 8px;
    background: ${Common.colors.aucMarkerColor};
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    cursor: pointer;

    @media screen and (max-width: 768px) {
        min-height: 0;
        padding: 10px 14px;
    }
`;

const InputPartnerCloseBtnStyle = styled.img`
    position: absolute;
    right: 82px;
    top: 16px;
`;

const ErrorTextStyle = styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #ff0000;
    min-height: 24px;
`;

const PartnerAgreeContents = styled.div`
    width: 276px;
    height: 154px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        text-align: center;
    }
    .contents {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
    }
`;

const ConfirmStyle = css`
    font-size: 18px;
    height: 56;
`;
